import { Document } from "@/types/documents";
import { Button } from "@/components/ui/button";
import { Dialog, DialogTrigger } from "@/components/ui/dialog";
import { Edit, Eye, Download, Trash } from "lucide-react";

interface DocumentListItemProps {
  document: Document;
  onEdit: () => void;
  onPreview: () => void;
  onDownload: () => void;
  onDelete: () => void;
}

export const DocumentListItem = ({
  document,
  onEdit,
  onPreview,
  onDownload,
  onDelete,
}: DocumentListItemProps) => {
  return (
    <div className="flex justify-between items-center p-3 bg-secondary/50 rounded-lg">
      <div className="flex items-center space-x-3">
        <span className="text-foreground">{document.name}</span>
        <span className="text-sm text-muted-foreground">
          {(document.size / 1024 / 1024).toFixed(2)} MB
        </span>
      </div>
      <div className="flex items-center space-x-2">
        <span className="text-sm text-muted-foreground">
          {new Date(document.created_at).toLocaleDateString()}
        </span>
        <div className="flex space-x-2">
          <Dialog>
            <DialogTrigger asChild>
              <Button
                variant="outline"
                size="sm"
                onClick={onEdit}
              >
                <Edit className="w-4 h-4" />
              </Button>
            </DialogTrigger>
          </Dialog>

          <Dialog>
            <DialogTrigger asChild>
              <Button
                variant="outline"
                size="sm"
                onClick={onPreview}
              >
                <Eye className="w-4 h-4" />
              </Button>
            </DialogTrigger>
          </Dialog>

          <Button
            variant="outline"
            size="sm"
            onClick={onDownload}
          >
            <Download className="w-4 h-4" />
          </Button>

          <Button
            variant="outline"
            size="sm"
            onClick={onDelete}
            className="text-destructive hover:text-destructive"
          >
            <Trash className="w-4 h-4" />
          </Button>
        </div>
      </div>
    </div>
  );
};